import { useState } from 'react';

import { useContactContext } from 'lib/common/contexts/ContactContext';

import { CONTACT_END_TASK_WARNING } from '../../constants/contactAttributes';
import getContactAttributes from '../../utils/getContactAttributes';
import { getTask } from '../../utils/getTask';
import EndTaskWarningModal from './components/EndTaskWarningModal';

export default function useHangUpAgent(taskId: string) {
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);

  const {
    actions: { hangupAgent },
    state: { tasks },
  } = useContactContext();

  const useEndTaskWarning = (taskId: string) => {
    const task = getTask(tasks, taskId);
    const isWarningAttribute = getContactAttributes({ task }, CONTACT_END_TASK_WARNING);

    if (isWarningAttribute[CONTACT_END_TASK_WARNING]) {
      return { warningMessage: isWarningAttribute[CONTACT_END_TASK_WARNING], taskType: task?.type };
    }

    return;
  };

  const isWarningMessageAttribute = useEndTaskWarning(taskId);

  const handleHangUpAgent = () => {
    if (isWarningMessageAttribute !== undefined) {
      setIsWarningModalOpen(true);
      return;
    }

    return hangupAgent(taskId);
  };

  return {
    endTaskWarningModal: (
      <EndTaskWarningModal
        open={isWarningModalOpen}
        onClose={() => setIsWarningModalOpen(false)}
        onSave={() => hangupAgent(taskId)}
        bodyText={isWarningMessageAttribute?.warningMessage}
        taskType={isWarningMessageAttribute?.taskType}
      />
    ),
    actions: { handleHangUpAgent },
  };
}
